import React, { createContext, useContext, useMemo } from "react";
import APIInstance from "./APIInstance";

const APIContext = createContext(APIInstance)

const ApiProvider: React.FC<{children: React.ReactNode}> = (props) => {
    //const value = useMemo(()=>(APIInstance), [APIInstance])
    return (
        <APIContext.Provider value={APIInstance}>
            {props.children}
        </APIContext.Provider>
    );
};

const useApi = () => useContext(APIContext)

export {ApiProvider, useApi};
